<template>
  <div class="load-cloud-page">
    <div ref="containerRef" class="load-cloud-viewport"></div>

    <div class="load-cloud-card">
      <GraphicsBackendControlCard :card="graphicsCard" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { presets } from '@sharefe/share3d-engine'
import { onMounted, useTemplateRef } from 'vue'
import { useExampleGraphicsCard } from '../composables/useExampleGraphicsCard'
import { usePotreeEngine } from '../hooks'
import { toGraphicsRuntimeError } from '../utils/graphicsRuntimeError'
import GraphicsBackendControlCard from './GraphicsBackendControlCard.vue'

const containerRef = useTemplateRef('containerRef')
const graphicsCard = useExampleGraphicsCard({ presetKey: 'pointCloudOnly' })

const { engine, init, actualBackend } = usePotreeEngine(containerRef, {
  backend: graphicsCard.requestedBackend.value,
  plugins: presets.pointCloudOnly(),
  background: 'black',
})

onMounted(async () => {
  await graphicsCard.runPreflight()
  try {
    await init()
  } catch (error) {
    graphicsCard.markError(toGraphicsRuntimeError(error))
    return
  }
  graphicsCard.markReady(actualBackend.value)

  const engineInstance = engine.value
  if (!engineInstance) return

  const handle = await engineInstance.loadPointCloud({
    url: '/converted_r/metadata.json',
    name: 'test',
  })

  console.log('[LoadCloud] 点云加载完成:', 'id=' + handle.id)
  engineInstance.fitAll()
})
</script>

<style scoped>
.load-cloud-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: #000;
}

.load-cloud-viewport {
  width: 100%;
  height: 100%;
}

.load-cloud-card {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 300px;
  pointer-events: auto;
}
</style>
